// 보안 허용 목록 및 자동 민감도 감지를 위한 MFM 태그 분류

// 허용된 MFM 태그 전체 목록 (allowlist)
export const MFM_ALLOWED_TAGS = new Set([
  'tada',
  'jelly',
  'twitch',
  'shake',
  'spin',
  'jump',
  'bounce',
  'flip',
  'x2',
  'x3',
  'x4',
  'scale',
  'position',
  'fg',
  'bg',
  'border',
  'font',
  'blur',
  'rainbow',
  'sparkle',
  'rotate',
  'ruby',
  'unixtime',
]);

// 광과민성 경고를 유발하는 태그 (자동 민감도 적용)
// 빠른 시각적 변화를 포함: 애니메이션, 변환, 색상 순환
export const MFM_PHOTOSENSITIVE_TAGS = new Set([
  'tada',
  'jelly',
  'twitch',
  'shake',
  'spin',
  'jump',
  'bounce',
  'rainbow',
  'sparkle',
]);

// 크기/위치 변환을 포함하는 태그 (큰 값에 대해 자동 민감도 적용)
export const MFM_TRANSFORM_TAGS = new Set(['x3', 'x4', 'scale', 'position']);

// 프로필에서 허용되는 태그 (애니메이션 및 변환 제외)
export const MFM_PROFILE_ALLOWED_TAGS = new Set([
  'fg',
  'bg',
  'border',
  'font',
  'ruby',
  'unixtime',
]);

// 허용된 폰트 패밀리 목록 (whitelist)
export const MFM_ALLOWED_FONTS = new Set([
  'serif',
  'monospace',
  'cursive',
  'fantasy',
  'emoji',
  'math',
]);

// 허용된 테두리 스타일 목록 (whitelist)
export const MFM_ALLOWED_BORDER_STYLES = new Set([
  'hidden',
  'dotted',
  'dashed',
  'solid',
  'double',
  'groove',
  'ridge',
  'inset',
  'outset',
]);

// 최대 배율 크기
export const MFM_MAX_SCALE = 5;

// 최대 컨테이너 높이 (px)
export const MFM_MAX_CONTAINER_HEIGHT = 600;
